import { createSelector } from '@ngrx/store';
import * as statementsMainReducer from '../employee-detail.reducer';
import * as statementsSubState from '../reducers/statements.reducer';

export const selectStatements = createSelector(statementsMainReducer.getStatementsState, statementsSubState.getStatements);
